export const LS_ROVO_SIDEBAR_STATE_KEY = 'rovo-sidebar-state';
